import Button from 'components/Button/Button';
import Icon from 'components/Icon/Icon';
import Text from 'components/Text/Text';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {updateSingleBeerACS} from 'store/beers/requestAC';
import {setPreviewSrcAC} from 'store/imageUploader/imageUploaderSlice';
import {setModalAC} from 'store/modal/modalSlice';
import {CreateBeerDTO} from 'typescript/dto/beersDto';

import './DeleteBeerPhoto.scss';

const DeleteBeerPhoto = () => {
  const dispatch = useSetGlobalState();
  const {singleBeer} = useGlobalState((state) => state.beerPreview);

  const handleCancel = () => dispatch(setModalAC(null));

  const handleDelete = () => {
    if (singleBeer) {
      const {attributes} = singleBeer;
      const {name, details, abv, ibu, brewery_id, beer_style_id} = attributes;

      const updatedBeer: CreateBeerDTO = {
        name,
        details,
        abv: +abv,
        ibu: +ibu,
        brewery_id,
        beer_style_id,
        beer_logo: null,
      };

      dispatch(updateSingleBeerACS({id: singleBeer.id, data: updatedBeer}));
      dispatch(setPreviewSrcAC(undefined));
      handleCancel();
    }
  };

  return (
    <div className="delete-beer-photo" data-testid="delete-beer-photo">
      <div className="delete-beer-photo__header">
        <div className="delete-beer-photo__title">
          <Text tag="span">DELETE PHOTO</Text>
        </div>
        <div className="delete-beer-photo__close" onClick={handleCancel} data-testid="close-modal" role="button">
          <Icon icon="close" />
        </div>
      </div>
      <Text tag="p">Are you sure you want to delete beer photo?</Text>
      <div className="delete-beer-photo__buttons">
        <Button variant="text" onClick={handleCancel}>
          Cancel
        </Button>
        <div className="delete-beer-photo__divider" />
        <Button variant="secondary" onClick={handleDelete}>
          Delete
        </Button>
      </div>
    </div>
  );
};

export default DeleteBeerPhoto;
